import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

Modal.setAppElement("#root");

export default function Create_scrap() {
  const title = "Add Data";
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [clients, setClients] = useState([]);

  const [formData, setFormData] = useState({
    id_user: "",
    id_vehicle: "",
    actual_vehicle: "",
    id_client: "",
    comments: "",
  });

  const [errors, setErrors] = useState({});

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUsers(response.data.users);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };
    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };
    fetchVehicles();
  }, []);
  const handleVehicleChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_vehicle: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleActualVehicleChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      actual_vehicle: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setClients(response.data.clients);
      } catch (error) {
        console.error("Error fetching client:", error);
        setClients([]);
      }
    };
    fetchClients();
  }, []);
  const handleClientChange = (selectedOption) => {
    setFormData({
      ...formData,
      id_client: selectedOption ? selectedOption.value : "",
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.id_vehicle) {
      newErrors.id_vehicle = "Vehicle Id  is required.";
    }
    if (!formData.actual_vehicle) {
      newErrors.actual_vehicle = "Actual Vehicle is required.";
    }
    if (!formData.id_user) {
      newErrors.id_user = "User is required.";
    }
    if (!formData.id_client) {
      newErrors.id_client = "Client  is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleUserChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_user: selectedOption ? selectedOption.value : "",
    }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const data = new FormData();
    if (formData.id_user) {
      data.append("id_user", formData.id_user);
    }
    if (formData.comments) {
      data.append("comments", formData.comments);
    }
    data.append("id_vehicle", formData.id_vehicle);
    data.append("actual_vehicle", formData.actual_vehicle);

    data.append("id_client", formData.id_client);
    for (let [key, value] of data.entries()) {
      console.log(`${key}: ${value}`);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/scrap`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("Response data:", response.data);

      if (response.status === 201) {
        navigate("/scrap");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      //   console.error("Error:", error);

      console.error("Error:", error.response ? error.response.data : error);
    }
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="id_client">
                  <b>Client </b>
                </label>

                <Select
                  name="id_client"
                  options={clients
                    .filter((client) => client.status === "Active")
                    .map((client) => ({
                      value: client._id,
                      label: client.name,
                    }))}
                  onChange={handleClientChange}
                  className={`basic-select ${
                    errors.id_client ? "is-invalid" : ""
                  }`}
                  classNamePrefix="select"
                />

                {errors.id_client && (
                  <p className="text-danger">{errors.id_client}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="id_user">
                  <b>Actual User </b>
                </label>
                <Select
                  name="id_user"
                  options={users
                    .filter((user) => user.status === "Active")
                    .map((user) => ({
                      value: user._id,
                      label: `${user.name || "Unknown Name"} (${
                        user.phonenumber || "Unknown Phone"
                      })`,
                    }))}
                  onChange={handleUserChange}
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="id_vehicle">
                  <b>Vehicle *</b>
                </label>
                <Select
                  name="id_vehicle"
                  options={vehicles
                    .filter((vehicle) => vehicle.status === "Active")
                    .map((vehicle) => ({
                      value: vehicle._id,
                      label: `${vehicle.numberplate}`,
                    }))}
                  onChange={(selectedOption) =>
                    handleVehicleChange(selectedOption)
                  }
                  classNamePrefix="select"
                />
                {errors.id_vehicle && (
                  <p className="text-danger">{errors.id_vehicle}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="actual_vehicle">
                  <b>Actual Vehicle *</b>
                </label>
                <Select
                  name="actual_vehicle"
                  options={vehicles
                    .filter((vehicle) => vehicle.status === "Active")
                    .map((vehicle) => ({
                      value: vehicle._id,
                      label: `${vehicle.numberplate}`,
                    }))}
                  onChange={(selectedOption) =>
                    handleActualVehicleChange(selectedOption)
                  }
                  classNamePrefix="select"
                />
                {errors.actual_vehicle && (
                  <p className="text-danger">{errors.actual_vehicle}</p>
                )}
              </div>

              <div className="col-md-6 mt-3"></div>
              <div className="col-12 mt-3">
                <label htmlFor="comments">
                  <b>Comments *</b>
                </label>
                <textarea
                  name="comments"
                  type="text"
                  placeholder="Enter Comments"
                  rows="5"
                  className="form-control"
                  value={formData.comments}
                  onChange={onChangeHandler}
                ></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Data
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
